<template>
  <div class="list-item">
    <div
      class="list-item__header"
      :class="{ 'list-item__header--readonly': readonly }"
    >
      <div
        v-if="!readonly"
        class="list-item__order"
        :class="{ 'list-item__order--disabled': isSingleItem }"
      >
        <span>
          {{ $t("message.storeLocator.faq.changeOrder") }}
        </span>
        <ui-button
          v-if="!isLast || isSingleItem"
          class="list-item__order-button"
          shadow
          icon="icon-arrow-down"
          :readonly="isSingleItem"
          @click="handleMoveDown"
        >
        </ui-button>
        <ui-button
          v-if="!isFirst"
          class="list-item__order-button"
          shadow
          icon="icon-arrow-up"
          @click="handleMoveUp"
        >
        </ui-button>
      </div>
      <div class="list-item__controls">
        <span v-if="date" class="list-item__date"
          >{{ $t("message.common.added") }}: {{ formattedDate }}</span
        >
        <template v-if="!readonly">
          <ui-button
            icon="icon-edit"
            shadow
            class="list-item__action-button"
            @click="handleShowEditDialog"
            >{{ $t("message.common.edit") }}</ui-button
          >
          <ui-button
            icon="icon-trash"
            iconColor="red"
            shadow
            class="list-item__action-button"
            @click="handleShowDeleteDialog"
            >{{ $t("message.common.delete") }}</ui-button
          >
        </template>
      </div>
    </div>
    <div class="list-item__content">
      <div class="list-item__title">
        {{ question }}
      </div>
      <p class="list-item__description">
        {{ answer }}
      </p>
    </div>
    <StoreLocatorFaqManageDialog
      v-if="showEditDialog"
      :edit-data="editDialogData"
      @close="showEditDialog = false"
      @update="handleUpdate"
    />
    <StoreLocatorFaqDeleteAlertDialog
      v-if="showDeleteDialog"
      @close="showDeleteDialog = false"
      @confirm="handleDelete"
    />
  </div>
</template>

<script>
export default {
  name: "StoreLocatorFaqListItem",
  components: {
    StoreLocatorFaqManageDialog: () =>
      import("@/components/StoreLocatorFaq/StoreLocatorFaqManageDialog.vue"),
    StoreLocatorFaqDeleteAlertDialog: () =>
      import(
        "@/components/StoreLocatorFaq/StoreLocatorFaqDeleteAlertDialog.vue"
      )
  },
  props: {
    question: {
      type: String,
      required: true
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    answer: {
      type: String,
      required: true
    },
    date: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showEditDialog: false,
      showDeleteDialog: false,
      editDialogData: null
    };
  },
  computed: {
    isSingleItem() {
      return this.isFirst && this.isLast;
    },
    formattedDate() {
      if (!this.date) return "";
      const date = new Date(this.date);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
  },
  methods: {
    getMovePayload(change_order) {
      return { change_order };
    },
    handleMoveDown() {
      this.$emit("move", this.getMovePayload(-1));
    },
    handleMoveUp() {
      this.$emit("move", this.getMovePayload(1));
    },
    handleDelete() {
      this.showDeleteDialog = false;
      this.$emit("delete");
    },
    handleShowDeleteDialog() {
      this.showDeleteDialog = true;
    },
    handleShowEditDialog() {
      this.showEditDialog = true;
      this.editDialogData = { question: this.question, answer: this.answer };
    },
    handleUpdate(payload) {
      this.editDialogData = null;
      this.showEditDialog = false;
      this.$emit("update", payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item {
  border-radius: 10px;
  border: 1px solid rgba(74, 36, 172, 0.2);
  background: #fff;
  padding: $spacing * 2;

  &__order {
    display: flex;
    align-items: center;
    gap: $spacing * 1.5;

    span {
      @include font-size(12px);
      color: $primary !important;
    }

    &--disabled {
      opacity: 0.6;
    }
  }

  &__order-button {
    &.v-btn {
      padding: 0 0 !important;
      height: 36px !important;
      width: 36px !important;
      min-width: 36px;
    }
  }

  &__action-button {
    &.v-btn {
      padding: 0 $spacing * 2.25 !important;
      height: 36px !important;
    }
  }

  &__action-text-button {
    &.v-btn {
      padding: 0 0 !important;
      height: 30px !important;
      color: $gray-900 !important;
      box-sizing: content-box;
      &:hover,
      &:focus {
        color: darken($gray-900, 20%) !important;
        background: transparent !important;
        border-radius: 0;

        &::before {
          display: none;
        }
      }
    }
  }

  &__header {
    display: flex;
    gap: $spacing * 2;
    justify-content: space-between;
    margin-bottom: $spacing;

    &--readonly {
      justify-content: flex-end;
    }
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: $spacing;
  }

  &__date {
    color: $gray-2;
    @include font-size(12px);
  }

  &__title {
    margin-bottom: $spacing;
    font-weight: 600;
    line-height: normal;
  }

  &__description {
    padding: 0;
    margin: 0;
    @include font-size(14px);
  }
}
</style>
